import React, { useState, useRef } from 'react';
import { Container, Row, Tab, Tabs, Col, FormGroup, Button, OverlayTrigger, Tooltip, Nav } from "react-bootstrap";
import { Input, Select, DatePicker, Table } from 'antd';
import { Breadcrumb, StoreHeader } from "../../components";
import { Link } from "react-router-dom";
function PromoCode() {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const breadcrumb = [
        {
            path: '/store-profile',
            name: 'Home',
        },
        {
            path: '#',
            name: 'promo code',
        },
    ];
    const columns = [
        {
            title: 'Promo Code',
            dataIndex: 'promoname',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: 'Discount',
            dataIndex: 'discount',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: 'Validity',
            dataIndex: 'validity',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: 'Activation Date',
            dataIndex: 'activationdate',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: 'Expiry Date',
            dataIndex: 'expirydate',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: 'Usage Limit',
            title: () => {
                return (
                    <>
                        Usage Linit
                        <OverlayTrigger
                            key='top'
                            placement='top'
                            overlay={
                                <Tooltip id='tooltip-top'>
                                    Lorem ipsum dolor sit amet.
                                </Tooltip>
                            }
                        >
                            <Link to="#" ref={target} onClick={() => setShow(!show)}>
                                <em className="gg-infomore ms-2" />
                            </Link>
                        </OverlayTrigger>
                    </>
                );
            },
            dataIndex: 'usagelimit',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: () => {
                return (
                    <>
                        Customer Usage
                        <OverlayTrigger
                            key='top'
                            placement='top'
                            overlay={
                                <Tooltip id='tooltip-top'>
                                    Lorem ipsum dolor sit amet.
                                </Tooltip>
                            }
                        >
                            <Link to="#" ref={target} onClick={() => setShow(!show)}>
                                <em className="gg-infomore ms-2" />
                            </Link>
                        </OverlayTrigger>
                    </>
                );
            },
            dataIndex: 'customerusage',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: () => {
                return (
                    <>
                        Pending Amount
                        <OverlayTrigger
                            key='top'
                            placement='top'
                            overlay={
                                <Tooltip id='tooltip-top'>
                                    Lorem ipsum dolor sit amet.
                                </Tooltip>
                            }
                        >
                            <Link to="#" ref={target} onClick={() => setShow(!show)}>
                                <em className="gg-infomore ms-2" />
                            </Link>
                        </OverlayTrigger>
                    </>
                );
            },
            dataIndex: 'pendingamount',
            sorter: {
                compare: (a, b) => a.chinese - b.chinese
            },
        },
        {
            title: 'Transferred Amount',
            dataIndex: 'transferredamount'
        }
    ];
    const data = [
        {
            key: '1',
            promoname: '#12345',
            discount: '10%',
            validity: '10 Day',
            activationdate: '02-01-2023',
            expirydate: '02-01-2023',
            usagelimit: '0000',
            customerusage: '0000',
            pendingamount: '$321',
            transferredamount: '$200'
        },
        {
            key: '2',
            promoname: '#12346',
            discount: '10%',
            validity: '10 Day',
            activationdate: '02-01-2023',
            expirydate: '02-01-2023',
            usagelimit: '0000',
            customerusage: '0000',
            pendingamount: '$321',
            transferredamount: '$200'
        },
        {
            key: '3',
            promoname: '#12347',
            discount: '10%',
            validity: '10 Day',
            activationdate: '02-01-2023',
            expirydate: '02-01-2023',
            usagelimit: '0000',
            customerusage: '0000',
            pendingamount: '$321',
            transferredamount: '$200'
        },
    ];


    return (
        <>
            <StoreHeader />
            <div className="main-content promoPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <div className="d-flex justify-content-between">
                            <Breadcrumb title="Promo Code" breadcrumb={breadcrumb} />
                            <Button type="button" variant="outline-info">Export</Button>
                        </div>
                        <div className="cardHeight bg-white br-10">
                            <div className="commonTabs">
                                <Nav
                                    activeKey="/today"
                                    className='nav-tabs'
                                    >
                                    <Nav.Item>
                                        <Nav.Link href="/today">Today</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-1">Yesterday</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-2">Current Week</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-3">Previous Week</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-4">Current Month</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-5">Previous Month</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-6">Current Year</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="link-7">Previous Year</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <div>
                                    <div className="promoPage_filter d-flex flex-wrap">
                                        <FormGroup className="form-group">
                                            <label className="ant-label">From Date</label>
                                            <DatePicker className="ant-input ant-input-lg datePicker-ant" />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <label className="ant-label">To Date</label>
                                            <DatePicker className="ant-input ant-input-lg datePicker-ant" />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <label className="ant-label d-none d-md-block">&nbsp;</label>
                                            <Select size="large" className="w-100" placeholder="All"
                                                options={[
                                                    {
                                                        value: 'Promo Code',
                                                        label: 'Promo Code',
                                                    },
                                                    {
                                                        value: 'Yesterday',
                                                        label: 'Yesterday',
                                                    },
                                                ]}
                                            />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <label className="ant-label d-none d-md-block">&nbsp;</label>
                                            <Input size="large" placeholder="" />
                                        </FormGroup>
                                        <FormGroup className="promoPage_filter_btns form-group">
                                            <label className="ant-label d-none d-lg-block">&nbsp;</label>
                                            <div className="d-flex align-self-end">
                                                <Button variant="info" className='btn-lg'>search</Button>
                                                <Button variant="primary" className='btn-lg'>reset</Button>
                                            </div>
                                        </FormGroup>
                                    </div>
                                    <div className="promoPage_table">
                                        <div className="table-responsive">
                                            <Table
                                                columns={columns}
                                                dataSource={data}
                                                pagination={false}
                                                showSorterTooltip={false}
                                            />                                            
                                        </div>
                                        <p className="mb-0 ft-14 text-end mt-1">Showing 1 to 1 of 1 entries</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default PromoCode;